export default __webpack_public_path__ + "4b87937a3a849db9541f5bf9be21b3de.svg";